export class Env {
    constructor(){
        this.ua = '';
        this.isiPhoneXSeries = false;
    }
    detectEnv(){
        this.body = document.getElementsByTagName('body')[0];
        this.html = document.getElementsByTagName('html')[0];

        // IE11 detection
        this.ua = window.navigator.userAgent.toLowerCase();
        //console.log(this.ua);

        this.browser = {};
        if(this.ua.indexOf('msie') != -1 || this.ua.indexOf('trident') != -1) {
            this.browser.ie11 = true;
			this.body.classList.add('ie11');
			this.html.classList.add('ie11');
        } else if(this.ua.indexOf('edge') != -1) {
            this.browser.edge = true;
            this.body.classList.add('edge');
        } else if(this.ua.indexOf('chrome') != -1) {
            this.browser.chrome = true;
            this.body.classList.add('chrome');
        } else if(this.ua.indexOf('safari') != -1) {
            this.browser.safari = true;
            this.body.classList.add('safari');
        } else if(this.ua.indexOf('firefox') != -1) {
            this.browser.firefox = true;
            this.body.classList.add('firefox');
        } else if(this.ua.indexOf('opera') != -1) {
            this.browser.opera = true;
            this.body.classList.add('opera');
        }

        //OS
        if(this.ua.indexOf("windows nt") !== -1) {
            //console.log("「Microsoft Windows」をお使いですね!");
            this.body.classList.add('os-windows');
        } else if(this.ua.indexOf("android") !== -1) {
            //console.log("「Android」をお使いですね!");
            this.body.classList.add('os-android');
        } else if(this.ua.indexOf("iphone") !== -1 || this.ua.indexOf("ipad") !== -1) {
            //console.log("「iOS」をお使いですね!");
            this.body.classList.add('os-ios');
        } else if(this.ua.indexOf("mac os x") !== -1) {
            //console.log("「macOS」をお使いですね!");
            this.body.classList.add('os-mac');
        }

        //iPhoneX(ホームバー・ノッチのある機種)かどうか
        const isiPhone = /iPhone/.test(window.navigator.userAgent);
        const currentDevicePixel = (window.screen.width * window.screen.height * window.devicePixelRatio);
        const iPhoneXSeriesScreenPixelList =
            [
                (375 * 812 * 3), // iPhone X, XS, 11 Pro
                (414 * 896 * 3), // iPhone XS Max, 11 Pro Max
                (414 * 896 * 2)  // iPhone XR, 11
            ];
        if(isiPhone && iPhoneXSeriesScreenPixelList.some((item) => item === currentDevicePixel)){
            this.isiPhoneXSeries = true;
            this.body.classList.add('os-ios-x');
        }
    
        // クリックとタップ判定　
        // 注 _click 指定時はクォーテーションで囲わないこと
        if(window.ontouchstart === null){//null undefined
            this._click = 'touchstart';
            this.body.classList.add('device-touch');
            this.body.classList.remove('device-click');
            //console.log('resize-tou');
        }else{
            this._click = 'click';
            this.body.classList.add('device-click');
            this.body.classList.remove('device-touch');
            //console.log('resize-cl');
        }
    }

    getClick(){
        if(window.ontouchstart === null){
            return 'touchstart';
        }else{
            return 'click';
        }
    }
    
}